export const normalizeErrorMessage = (error: unknown, fallback = 'Unknown error') => {
  if (error instanceof Error) return error.message || fallback;
  if (typeof error === 'string') return error;
  return fallback;
};
